import { render, staticRenderFns } from "./addText.vue?vue&type=template&id=127d51a8&scoped=true"
import script from "./addText.vue?vue&type=script&lang=js"
export * from "./addText.vue?vue&type=script&lang=js"
import style0 from "./addText.vue?vue&type=style&index=0&id=127d51a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d51a8",
  null
  
)

export default component.exports